<div class="row">
    <div class="col-12 col-md-3">
        <div class="card rounded-0" >
            <div class="card-body">
                <form #f="ngForm" (ngSubmit)="f.valid && submit()" novalidate>
                    <h3 class="fs-4 fw-bold">Mass Voucher Generator</h3>
                    <div class="mb-3">
                        <label for="voucher_no" class="form-label">No of Voucher to generate <em>*</em></label>
                        <input type="number" class="form-control" id="voucher_no" name="voucher_no" #voucher_no="ngModel" [(ngModel)]="data.voucher_no" required>
                        <div *ngIf="f.submitted && voucher_no.invalid" class="invalid-feedback">
                            <div *ngIf="voucher_no.errors.required">Voucher number is required</div>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label for="winning" class="form-label">Winning <em>*</em></label>
                        <select class="form-control" name="winning" #winning="ngModel" [(ngModel)]="data.winning" required>
                            <option [value]="section.value" *ngFor="let section of sections">{{section.label}}</option>
                        </select>
                    </div>
                    <button type="submit" class="btn btn-primary">Update</button>
                </form>
            </div>
        </div>
